import { Input } from '@/components/ui/input';
import { Search, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SessionSearchProps {
  value: string;
  onChange: (value: string) => void;
  resultCount?: number;
}

export const SessionSearch = ({ value, onChange, resultCount }: SessionSearchProps) => {
  const handleClear = () => {
    onChange('');
  };

  return (
    <div className="relative">
      <div className="absolute left-2.5 sm:left-3 top-1/2 -translate-y-1/2 w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-gradient-to-br from-primary/15 to-primary/5 flex items-center justify-center pointer-events-none">
        <Search className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-primary" />
      </div>
      <Input
        type="text"
        placeholder="Suche..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-12 sm:pl-14 pr-9 sm:pr-10 h-10 sm:h-12 rounded-lg sm:rounded-xl border-border/50 bg-card focus:border-primary/30 focus:ring-primary/20 transition-all text-sm sm:text-base"
      />
      {value && (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleClear}
          className="absolute right-1.5 sm:right-2 top-1/2 -translate-y-1/2 h-7 w-7 sm:h-8 sm:w-8 p-0 rounded-lg hover:bg-primary/10 hover:text-primary"
          aria-label="Suche löschen"
        >
          <X className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
        </Button>
      )}
      {value && resultCount !== undefined && (
        <div className="absolute -bottom-5 sm:-bottom-6 left-0 text-[10px] sm:text-xs text-muted-foreground">
          {resultCount} {resultCount === 1 ? 'Ergebnis' : 'Ergebnisse'}
        </div>
      )}
    </div>
  );
};
